/* esm.sh - @radix-ui/react-alert-dialog@1.1.15 */
export * from "/*@radix-ui/react-alert-dialog@1.1.15/esnext/react-alert-dialog.mjs";
